"use strict";

exports.__esModule = true;
exports.LagIcon = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var LagIcon = exports.LagIcon = function LagIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "prefix__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    xmlSpace: "preserve"
  }, props, {
    width: props.width,
    height: props.height
  }), /*#__PURE__*/_react["default"].createElement("style", null, ".prefix__st1{fill:#fff}"), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#666"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "prefix__st1",
    d: "M35.1 24.7c0-5.7-4.7-10.6-10.6-10.6v10.6h10.6zM23.8 32.2h1.7v3.2h-1.7zM14.2 23.7h3.2v1.7h-3.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "rotate(-60 20.313 32.68)",
    className: "prefix__st1",
    d: "M18.7 32.2h3.2v.9h-3.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "rotate(-30 29.651 32.4)",
    className: "prefix__st1",
    d: "M29.2 30.8h.9V34h-.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "rotate(-30 20.544 16.577)",
    className: "prefix__st1",
    d: "M20.1 15h.9v3.2h-.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "rotate(-60.045 32.937 29.085)",
    className: "prefix__st1",
    d: "M32.5 27.5h.9v3.2h-.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "rotate(-60.045 17.12 19.835)",
    className: "prefix__st1",
    d: "M16.7 18.2h.9v3.2h-.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "rotate(-30.026 16.995 29.14)",
    className: "prefix__st1",
    d: "M15.4 28.7h3.2v.9h-3.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "prefix__st1",
    d: "M10.8 10.7c-1.3 1.1-1.3 2.8-.4 4l4.5-3.8c-.9-1-2.8-1.2-4.1-.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "prefix__st1",
    d: "M26.3 10.1V7.8h3v-3H19.1v3h3v2.3c-7 1.1-12.3 7.2-12.3 14.5 0 8.1 6.6 14.7 14.7 14.7s14.7-6.6 14.7-14.7c-.6-7.3-5.9-13.4-12.9-14.5zm-1.8 27.4c-7.1 0-12.8-5.7-12.8-12.8s5.7-12.8 12.8-12.8 12.8 5.7 12.8 12.8-5.7 12.8-12.8 12.8z"
  }));
};